import React from "react";

import styles from "./styles.scss";
import icon from "./icon.png";

function Logo() {
  return <img className={styles.logo} src={icon} />;
}

export { Logo };
